/* eslint-disable */
import Box from '@mui/material/Box'
import '../App.css'
import { useAuth, useBrowserQuery, useLocalStorage } from '@/hooks/common'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import SVG from 'react-inlinesvg'
import { SVGS } from '@/assets/svgs'
import TabLogo from '@/assets/svgs/tab-logo.svg'
import FullLogo from '@/assets/svgs/full-logo.svg'
import { styled } from '@mui/material/styles'
import { shallow } from 'zustand/shallow'
import { CreateNewPatternModal, Input, UserAvatar } from '@/components'
import { ModernCreateModal } from '@/components/ModernCreateModal'
import useAppStore from '@/store/useAppStore'
import { MoreVert, Menu as MenuIcon } from '@mui/icons-material'

import {
  Badge,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { useGetBasicInfo, useGetMyCircles, useGetMyConnections } from '@/hooks/api/dashboard'
import { useLocation, useNavigate } from 'react-router-dom'
import NotificationBadge from '@/assets/svgs/notification.svg'
import colors from '@/styles/colors'
import { RBox } from './__styled'
import { unix } from 'moment'
import PricingModal from './my-profile/components/PricingModal'

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '56px',
  padding: '0px 24px 0px 8px',
  backgroundColor: 'transparent',
  borderBottom: 'none',
  position: 'relative',
  zIndex: 100,
  width: '100%',
  maxWidth: '100%',

  '@media (max-width: 768px)': {
    padding: '0px 16px',
    height: '56px',
  },
}))

export const NotificationButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.15)',
  padding: 6,
  width: 32,
  height: 32,
  borderRadius: 8,
  border: '1px solid rgba(255, 255, 255, 0.2)',
  backdropFilter: 'blur(8px)',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    transform: 'translateY(-0.5px)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
  },

  '&:active': {
    transform: 'translateY(0px)',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },

  '& svg': {
    filter: 'brightness(0) invert(1)', // Make icon white
    width: '16px',
    height: '16px',
  },
}))

export const ButtonCreateNew = styled(IconButton)(({ theme }) => ({
  background: 'linear-gradient(135deg, #6C5CE7 0%, #8B5CF6 100%)',
  color: '#ffffff',
  fontSize: '13px',
  fontWeight: 500,
  borderRadius: '8px',
  height: '32px',
  alignItems: 'center',
  width: '120px',
  padding: '6px 16px',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  border: 'none',
  fontFamily: 'Inter, sans-serif',
  boxShadow: '0 2px 8px rgba(108, 92, 231, 0.3)',
  textTransform: 'none',
  whiteSpace: 'nowrap',

  '&:hover': {
    background: 'linear-gradient(135deg, #5B4FD1 0%, #7C3AED 100%)',
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 16px rgba(108, 92, 231, 0.4)',
  },

  '&:active': {
    transform: 'translateY(0px)',
    background: 'linear-gradient(135deg, #4F46BA 0%, #6D28D9 100%)',
    boxShadow: '0 2px 8px rgba(108, 92, 231, 0.3)',
  },
}))

export const ButtonUpgradePro = styled(IconButton)(({ theme }) => ({
  background: 'linear-gradient(125deg, #cb266d 0%, #464bd3 52%, #004da3 100%)',
  color: '#ffffff',
  fontSize: '13px',
  fontWeight: 600,
  borderRadius: '20px',
  height: '36px',
  alignItems: 'center',
  width: '140px',
  padding: '8px 18px',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  fontFamily: 'Inter, sans-serif',
  boxShadow: '0 4px 16px rgba(203, 38, 109, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  display: 'flex',
  gap: '8px',
  position: 'relative',
  overflow: 'hidden',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(125deg, #e91e63 0%, #5c6bc0 52%, #1976d2 100%)',
    borderRadius: '20px',
    opacity: 0,
    transition: 'opacity 0.3s ease',
    zIndex: 0,
  },

  '&:hover': {
    transform: 'translateY(-2px) scale(1.02)',
    boxShadow: '0 8px 25px rgba(203, 38, 109, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.3)',
    color: '#ffffff',
    '&::before': {
      opacity: 1,
    },
    '& svg': {
      color: '#ffd700',
    },
  },

  '&:active': {
    transform: 'translateY(-1px) scale(1.01)',
    boxShadow: '0 4px 16px rgba(203, 38, 109, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
  },

  '& > *': {
    position: 'relative',
    zIndex: 2,
  },

  '& svg': {
    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4))',
    color: '#ffd700 !important',
    width: '24px !important',
    height: '24px !important',
    position: 'relative',
    zIndex: 2,
  },

  '& .MuiTouchRipple-root': {
    display: 'none',
  },
}))

const pages = ['Products', 'Pricing', 'Blog']

export const Divider = styled(Box)(({ theme }) => ({
  height: '20px',
  width: '1px',
  backgroundColor: 'rgba(255, 255, 255, 0.25)',
  margin: '0px 16px',
  opacity: 0.6,
}))

export const AvatarWrapper = styled(Box)(({ theme }) => ({
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #6C5CE7 0%, #8B5CF6 100%)',
  padding: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',

  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 4px 16px rgba(108, 92, 231, 0.3)',
  },

  '&:active': {
    transform: 'scale(0.98)',
  },
}))

export default function ResponsiveNavBar() {
  const [ewUser] = useLocalStorage('ewUser', null)
  const location = useLocation()
  const query = useBrowserQuery()
  const searchKey = query.get('key') || ''
  const [searchText, setSearchText] = useState(searchKey)
  const { logout } = useAuth()
  const theme = useTheme()
  const navigate = useNavigate()
  const lessThanSmall = useMediaQuery(theme.breakpoints.down('md'))
  const [createNewModal, setCreateNewModal] = useState(false)
  const [enterpriseModal, setEnterpriseModal] = useState(false)
  const [pricingModalOpen, setPricingModalOpen] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const [notificationItems, unreadCount] = useAppStore(
    (state) => [state.notification.items, state.notification.unreadCount],
    shallow,
  )
  const {
    setShowSideMenuDrawer,
    resetTopicSearchResult,
    setSearchConnections,
    setSidebarCollapsed,
  } = useAppStore()

  const [sideTitle, profile, showSideMenuDrawer, sidebarCollapsed] = useAppStore(
    (state) => [
      state.app.sideTitle,
      state.user.profile,
      state.app.showSideMenuDrawer,
      state.home.sidebarCollapsed,
    ],
    shallow,
  )
  // const [profile] = useAppStore((state) => [state.user.profile], shallow)
  const getProfileData = useGetBasicInfo(ewUser?.userID)
  const getAllGroups = useGetMyCircles()
  const getAllConnections = useGetMyConnections()
  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const [showSearchBar, setShowSearchBar] = useState(false)
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null)
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null)

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  // Notifications now live on their own page (see src/features/notifications) —
  // no more header dropdown, matching every other primary surface in the v6 shell.
  const handleOpenNotificationMenu = () => {
    navigate('/notification')
  }

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  useEffect(() => {
    if (showSearchBar && inputRef.current) {
      inputRef.current.focus()
    }
  }, [showSearchBar])

  useEffect(() => {
    getProfileData.mutate({ isUserProfile: false })
  }, [])

  const profileName = useMemo(() => {
    if (profile) {
      return `${profile?.firstName} ${profile?.lastName}`
    }
    return 'Anonymous'
  }, [profile])

  const onClickNotification = () => {
    // setAnchorEl(null)
    // navigate('/notification')
  }

  const onClickProfile = () => {
    setAnchorElUser(null)
    navigate(`/settings`)
  }

  const onClickLogout = () => {
    setAnchorElUser(null)
    logout()
  }

  const navTitle = useMemo(() => {
    let result = sideTitle
    switch (location.pathname) {
      // Profile routes
      case '/profile/user':
        result = 'Profile'
        break
      case '/profile/me':
        result = 'My Profile'
        break
      case '/settings':
        result = 'Settings'
        break

      // Notification routes
      case '/notification':
        result = 'Notifications'
        break

      // Discover routes
      case '/discover/home':
        result = 'Recent Designs'
        break
      case '/discover/pattern':
        result = 'Patterns'
        break
      case '/discover/album':
        result = 'Albums'
        break
      case '/discover/gallery':
        result = 'Galleries'
        break
      case '/discover/custom_print':
        result = 'Custom Prints'
        break

      // Workspace routes
      case '/workspace/all':
        result = 'My Workspace'
        break
      case '/workspace/pattern':
        result = 'My Patterns'
        break
      case '/workspace/album':
        result = 'My Albums'
        break
      case '/workspace/gallery':
        result = 'My Galleries'
        break
      case '/workspace/custom_print':
        result = 'My Custom Prints'
        break
      case '/workspace/upload':
        result = 'Uploads'
        break

      // Project routes
      case '/projects/quilt':
        result = 'My Quilts'
        break
      case '/projects/gallery':
        result = 'My Project Galleries'
        break

      // Other routes
      case '/connections':
        result = 'Connections'
        break
      case '/circles':
        result = 'Circles'
        break
      case '/uploads':
        result = 'Uploads'
        break
      case '/search':
        result = 'Search Results'
        break
      case '/topic/create':
        result = 'Create Topic'
        break
      case '/share':
        result = 'Share'
        break
      case '/':
      case '/home':
      case '/topic':
        result = 'Recent Designs'
        break

      default:
        // Handle dynamic routes
        if (location.pathname.startsWith('/topic/edit/')) {
          result = 'Edit Topic'
        } else if (location.pathname.startsWith('/pattern')) {
          result = 'Pattern Editor'
        } else if (location.pathname.startsWith('/preview')) {
          result = 'Preview'
        } else {
          result = sideTitle || 'Dashboard'
        }
    }

    return result
  }, [sideTitle, location.pathname])

  const onChangeSearchText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value)
  }

  const onSearch = () => {
    navigate(`/search?key=${searchText}`)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.key === 'Enter') {
      resetTopicSearchResult()
      setSearchConnections({})
      navigate(`/search?key=${searchText}&q=${Date.now().toString()}`)
    }
  }

  const toggleModal = () => {
    setEnterpriseModal((prev) => !prev)
  }

  const handleCreateProject = (type: string, title: string) => {
    // Handle project creation based on type
    console.log('Creating project:', { type, title })
    // You can integrate with existing creation logic here
  }

  const renderBellIcon = useCallback(() => {
    return (
      <Box sx={{ marginRight: '20px' }}>
        <Badge badgeContent={unreadCount > 0 ? unreadCount : null} color='error'>
          <NotificationButton onClick={handleOpenNotificationMenu}>
            <SVG src={NotificationBadge} width={34} height={34} style={{ margin: 'auto' }} />
          </NotificationButton>
        </Badge>
      </Box>
    )
  }, [notificationItems])

  const renderAvatarButton = () => {
    return (
      <>
        <AvatarWrapper onClick={handleOpenUserMenu}>
          <UserAvatar
            size={32}
            borderRadius={50}
            url={profile?.profilePicURL}
            name={profileName}
            onClick={handleOpenUserMenu}
          />
        </AvatarWrapper>

        <Menu
          id='menu-user'
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <MenuItem
            key={'profile'}
            onClick={() => {
              handleCloseUserMenu()
              onClickProfile()
            }}
          >
            <RBox gap={'12px'}>
              <SVG
                src={SVGS.AccountCircleOutline}
                width={'20px'}
                height={'20px'}
                color={colors.themeBlueIconColor}
              />
              <Typography variant={'menuItem'} textAlign='center'>
                {'My Profile'}
              </Typography>
            </RBox>
          </MenuItem>

          <MenuItem
            key={'logout'}
            onClick={() => {
              handleCloseUserMenu()
              onClickLogout()
            }}
          >
            <RBox gap={'12px'}>
              <SVG src={SVGS.LogoutIcon} width={'20px'} height={'20px'} />
              <Typography variant={'menuItem'} textAlign='center'>
                {'Logout'}
              </Typography>
            </RBox>
          </MenuItem>
        </Menu>
      </>
    )
  }

  const renderTitle = () => {
    // navTitle
    const isSearchPage = location.pathname == '/search'
    return (
      <>
        <Typography
          variant='h2'
          sx={{
            fontSize: 16,
            fontWeight: isSearchPage ? 500 : 600,
            color: '#ffffff',
            letterSpacing: '-0.01em',
          }}
        >
          {isSearchPage ? 'Search Result for ' : navTitle}
        </Typography>
        {isSearchPage && searchKey.length > 0 && (
          <Typography
            variant={'large'}
            ml={'8px'}
            sx={{ color: '#ffffff' }}
          >{`"${searchKey}"`}</Typography>
        )}
      </>
    )
  }

  return (
    <Header sx={lessThanSmall ? { pl: '0px' } : {}}>
      <Toolbar disableGutters sx={{ flex: 1, justifyContent: 'space-between' }}>
        {/* Mobile Layout */}
        <Box
          sx={{
            flex: 1,
            display: lessThanSmall ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <IconButton
            onClick={() => setShowSideMenuDrawer(!showSideMenuDrawer)}
            sx={{
              color: '#ffffff',
              borderRadius: 2,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                transform: 'scale(1.05)',
              },
            }}
          >
            <MenuIcon />
          </IconButton>

          {renderTitle()}

          <Box flex={1} sx={{ display: 'flex', justifyContent: 'flex-end', pr: 1 }}>
            {showSearchBar ? (
              <Input
                inputRef={inputRef}
                value={searchText}
                placeholder='Search here'
                leftIcon={<SVG src={SVGS.SearchIcon} />}
                onChange={onChangeSearchText}
                name='search'
                sx={{ display: 'flex', maxWidth: '150px', borderRadius: '30px' }}
                size='small'
                onToggleIcon={onSearch}
                onKeyDown={handleKeyDown}
                onBlur={() => {
                  if (searchText.length == 0) setShowSearchBar(false)
                }}
              />
            ) : (
              <IconButton
                onClick={() => setShowSearchBar(true)}
                sx={{
                  color: '#ffffff',
                  borderRadius: 2,
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    color: '#ffffff',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <SVG src={SVGS.SearchIcon} width={'20px'} height={'20px'} />
              </IconButton>
            )}
          </Box>
          <IconButton
            onClick={toggleModal}
            sx={{
              color: '#ffffff',
              borderRadius: 2,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                transform: 'scale(1.05)',
              },
            }}
          >
            <SVG src={SVGS.TabPlus} width={'28px'} height={'28px'} />
          </IconButton>
          <Divider sx={{ margin: '0px 12px 0px 6px' }} />
          {renderBellIcon()}
          {renderAvatarButton()}
        </Box>

        {/* Desktop Layout */}
        <Box
          sx={{
            display: lessThanSmall ? 'none' : 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '24px',
          }}
        >
          {/* Left Section - Full Logo, Hamburger Menu, and Title */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', minWidth: '200px' }}>
            {/* Full Logo */}
            <Box
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => navigate('/')}
            >
              <SVG
                src={FullLogo}
                width={120}
                height={36}
                style={{ filter: 'brightness(0) invert(1)', marginLeft: '6px' }}
              />
            </Box>

            {/* Hamburger Menu Button */}
            <IconButton
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              sx={{
                color: '#ffffff',
                padding: '8px',
                borderRadius: '8px',
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              <MenuIcon />
            </IconButton>

            {renderTitle()}
          </Box>

          {/* Center Section - Prominent Search Box */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '600px',
            }}
          >
            <Input
              inputRef={inputRef}
              value={searchText}
              placeholder='Search for content or create your own'
              leftIcon={<SVG src={SVGS.SearchIcon} />}
              onChange={onChangeSearchText}
              name='search'
              sx={{
                width: '100%',
                maxWidth: '600px',
                borderRadius: '24px',
                backgroundColor: 'transparent',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  border: '2px solid rgba(255, 255, 255, 0.4)',
                },
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'transparent',
                  borderRadius: '24px',
                  border: 'none',
                  height: '40px',
                  '& fieldset': {
                    border: 'none',
                  },
                  '&:hover fieldset': {
                    border: 'none',
                  },
                  '&.Mui-focused fieldset': {
                    border: 'none',
                  },
                  '&.Mui-focused': {
                    backgroundColor: '#ffffff',
                    '& .MuiInputBase-input': {
                      color: '#1a1a1a',
                      '&::placeholder': {
                        color: '#9ca3af',
                      },
                    },
                    '& .MuiInputAdornment-root svg': {
                      color: '#6b7280',
                      filter: 'none',
                    },
                  },
                },
                '& .MuiInputBase-input': {
                  padding: '10px 16px 10px 44px',
                  fontSize: '14px',
                  color: '#ffffff',
                  fontWeight: 400,
                  '&::placeholder': {
                    color: 'rgba(255, 255, 255, 0.7)',
                    opacity: 1,
                    fontWeight: 400,
                  },
                },
                '& .MuiInputAdornment-root': {
                  position: 'absolute',
                  left: '14px',
                  '& svg': {
                    color: 'rgba(255, 255, 255, 0.7)',
                    width: '18px',
                    height: '18px',
                    filter: 'brightness(0) invert(1) opacity(0.7)',
                  },
                },
              }}
              size='medium'
              onToggleIcon={onSearch}
              onKeyDown={handleKeyDown}
            />
          </Box>

          {/* Right Section - Actions */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              minWidth: '200px',
              justifyContent: 'flex-end',
            }}
          >
            <ButtonUpgradePro onClick={() => setPricingModalOpen(true)}>
              <SVG src={SVGS.CrownIcon} width={24} height={24} />
              <span>Upgrade Pro</span>
            </ButtonUpgradePro>
            <ButtonCreateNew onClick={toggleModal}>+ Create New</ButtonCreateNew>
            <Divider />
            {renderBellIcon()}
            {renderAvatarButton()}
          </Box>
        </Box>
      </Toolbar>
      <ModernCreateModal
        open={enterpriseModal}
        onClose={() => setEnterpriseModal(false)}
        onCreateProject={handleCreateProject}
      />
      <CreateNewPatternModal
        open={createNewModal}
        onClose={() => {
          setCreateNewModal(false)
        }}
      />
      <PricingModal open={pricingModalOpen} onClose={() => setPricingModalOpen(false)} userId={ewUser?.userID} userEmail={ewUser?.userName} />
    </Header>
  )
}
